/**
 * Recarrega uma vez quando o service worker novo assume o controle.
 *
 * Cicatriz (07/08/2026, produção): depois de deployar o ciclo de vida do KB, o
 * Leandro abriu o portal e não achou "Arquivar" nem "Excluir". O código estava
 * no ar, o navegador é que rodava o bundle anterior: `index-QCD1AMlR.js`
 * enquanto o servidor entregava `index-B9nl5g_d.js`.
 *
 * A causa é o `registerType: 'autoUpdate'` do vite-plugin-pwa. Ele faz o certo
 * (baixa o SW novo, `skipWaiting`, assume o controle), mas há uma latência de
 * **uma carga**: a visita em que o SW novo é baixado ainda é servida pelo antigo,
 * porque o `index.html` vem do precache. Só a visita SEGUINTE vê a versão nova.
 * Sem nada avisando, a pessoa conclui que a feature não foi entregue.
 *
 * `controllerchange` dispara exatamente quando o SW novo toma o controle. Nesse
 * instante o precache já é o novo, então recarregar entrega a versão nova na hora
 *, troca "app velho em silêncio" por "um blink de recarga".
 *
 * A trava de sessão existe porque `controllerchange` também dispara no primeiro
 * registro (não havia controlador antes): sem ela, a primeira visita de todo mundo
 * recarregaria sem motivo.
 */

const CHAVE = 'sw:recarregado'

export function instalarAtualizacaoDoServiceWorker(
  recarregar: () => void = () => window.location.reload()
): void {
  // Checar o VALOR, não a chave: `'serviceWorker' in navigator` é verdadeiro mesmo
  // quando a propriedade existe valendo `undefined`, e a linha seguinte estouraria.
  if (!navigator.serviceWorker) return

  // Sem controlador = primeiro registro nesta origem. O `controllerchange` que vem
  // a seguir é a instalação inicial, não uma versão nova: nada a recarregar.
  const primeiroRegistro = !navigator.serviceWorker.controller

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (primeiroRegistro) return
    if (sessionStorage.getItem(CHAVE) === '1') return
    sessionStorage.setItem(CHAVE, '1')
    recarregar()
  })
}

/** Chamar quando o app monta: libera a próxima atualização a recarregar. */
export function limparTravaDeRecarga(): void {
  sessionStorage.removeItem(CHAVE)
}
